/* eslint-disable import/prefer-default-export */
import { Plugins, Config } from '@leverege/plugin';
const historyRanges = [undefined, 'yesterday', 'today', 'last24Hours', 'last7Days'];
const defaultSecondaryAttributeCreators = [...historyRanges.reduce((prev, range) => {
  prev.push({
    options: {
      function: 'min',
      type: 'float',
      range
    },
    type: 'historyAggregation'
  }, {
    options: {
      function: 'max',
      type: 'float',
      range
    },
    type: 'historyAggregation'
  }, {
    options: {
      function: 'avg',
      type: 'float',
      range
    },
    type: 'historyAggregation'
  }, {
    options: {
      function: 'stddev',
      type: 'float',
      range
    },
    type: 'historyAggregation'
  });
  return prev;
}, []), {
  options: {
    comparisonTimestamp: 'now'
  },
  type: 'timeSinceTimestamp'
}];
export const AttributeCreatorFactory = Plugins.createFactory('AttributeCreator', {
  pluginKey: 'create',
  strategy: Plugins.LOOKUP
});
export const getSecondaryAttributeCreators = attribute => {
  const defs = Config.get('Attribute', 'secondaryAttributeCreators', defaultSecondaryAttributeCreators);
  const user = attribute?.metadata?.secondaryAttributeCreators || [];
  return [...defs, ...user];
};